export default "__VITE_ASSET__orf4Z8NP__"